import epgTime from '@/shared/libs/time';

const DEFAULT_LOADING_ADVANCE = 60;

export default {
  data() {
    return {
      info: this.$services.resolve('info'),
      manager: this.$services.resolve('liveManager'),
      time: this.$services.resolve('time'),
      epgTime,
    };
  },
  computed: {
    loadingAdvance() {
      const { epgLoadingAdvanceInSeconds = DEFAULT_LOADING_ADVANCE } = this.info.platformSettings;
      return Math.round(Math.random() * epgLoadingAdvanceInSeconds);
    },
  },
  methods: {
    fillPrograms(liveProducts, since = this.time.now.clone().startOf('day'), till = this.time.now.clone().endOf('day')) {
      const products = Array.isArray(liveProducts) ? liveProducts : [liveProducts];

      return this.manager.init(this.time)
        .then(() => this.manager.fillPrograms(products, since, till));
    },
    getRange() {
      const { now } = this.time;

      return {
        since: now.startOf('day').add(this.epgTime.dayOffset, 'd').valueOf(),
        till: now.endOf('day').add(this.epgTime.dayOffset, 'd').valueOf(),
      };
    },
  },
};
